var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1568_10384",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.320312,
    y: 0.202942,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1568_10384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3203 11.2029C14.8203 11.2029 16.9453 10.8113 18.6953 10.0279C20.4453 9.24461 21.3203 8.30294 21.3203 7.20294C21.3203 6.10294 20.4453 5.16128 18.6953 4.37794C16.9453 3.59461 14.8203 3.20294 12.3203 3.20294C9.82031 3.20294 7.69531 3.59461 5.94531 4.37794C4.19531 5.16128 3.32031 6.10294 3.32031 7.20294C3.32031 8.30294 4.19531 9.24461 5.94531 10.0279C7.69531 10.8113 9.82031 11.2029 12.3203 11.2029ZM12.3203 13.7029C13.0036 13.7029 13.8578 13.6321 14.8828 13.4904C15.9078 13.3488 16.8953 13.1196 17.8453 12.8029C18.7953 12.4863 19.612 12.0738 20.2953 11.5654C20.9786 11.0571 21.3203 10.4363 21.3203 9.70294V12.2029C21.3203 12.9363 20.9786 13.5571 20.2953 14.0654C19.612 14.5738 18.7953 14.9863 17.8453 15.3029C16.8953 15.6196 15.9078 15.8488 14.8828 15.9904C13.8578 16.1321 13.0036 16.2029 12.3203 16.2029C11.637 16.2029 10.7828 16.1321 9.75781 15.9904C8.73281 15.8488 7.74531 15.6196 6.79531 15.3029C5.84531 14.9863 5.02865 14.5738 4.34531 14.0654C3.66198 13.5571 3.32031 12.9363 3.32031 12.2029V9.70294C3.32031 10.4363 3.66198 11.0571 4.34531 11.5654C5.02865 12.0738 5.84531 12.4863 6.79531 12.8029C7.74531 13.1196 8.73281 13.3488 9.75781 13.4904C10.7828 13.6321 11.637 13.7029 12.3203 13.7029ZM12.3203 18.7029C13.0036 18.7029 13.8578 18.6321 14.8828 18.4904C15.9078 18.3488 16.8953 18.1196 17.8453 17.8029C18.7953 17.4863 19.612 17.0738 20.2953 16.5654C20.9786 16.0571 21.3203 15.4363 21.3203 14.7029V17.2029C21.3203 17.9363 20.9786 18.5571 20.2953 19.0654C19.612 19.5738 18.7953 19.9863 17.8453 20.3029C16.8953 20.6196 15.9078 20.8488 14.8828 20.9904C13.8578 21.1321 13.0036 21.2029 12.3203 21.2029C11.637 21.2029 10.7828 21.1321 9.75781 20.9904C8.73281 20.8488 7.74531 20.6196 6.79531 20.3029C5.84531 19.9863 5.02865 19.5738 4.34531 19.0654C3.66198 18.5571 3.32031 17.9363 3.32031 17.2029V14.7029C3.32031 15.4363 3.66198 16.0571 4.34531 16.5654C5.02865 17.0738 5.84531 17.4863 6.79531 17.8029C7.74531 18.1196 8.73281 18.3488 9.75781 18.4904C10.7828 18.6321 11.637 18.7029 12.3203 18.7029Z",
    fill: "#4BB6B9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseIcon);
export default __webpack_public_path__ + "static/media/database_icon.b676485ef9311159aa37313a159746ac.svg";
export { ForwardRef as ReactComponent };